export default {
	title: 'sensor_actions',
	icon: 'far fa-link',
	components: [{ title: 'sensor_actions', component: 'sensor_actions' }],
};
